import { FC, lazy, Suspense } from 'react';
import { graphql, useFragment } from 'react-relay';

import { usePrerenderedCheckoutStore } from '../../prerender/prerenderedCheckoutStoreReact';

const CheckoutHelpContent = lazy(
    () => import(/* webpackChunkName: "CheckoutHelpContent" */ './CheckoutHelpContent')
);

import type { CheckoutHelp_viewer$key } from './__generated__/CheckoutHelp_viewer.graphql';
import type { CheckoutHelp_buyer$key } from './__generated__/CheckoutHelp_buyer.graphql';

const viewerFragment = graphql`
    fragment CheckoutHelp_viewer on Viewer {
        ...CheckoutHelpContent_viewer
    }
`;

const buyerFragment = graphql`
    fragment CheckoutHelp_buyer on User {
        ...CheckoutHelpContent_buyer
    }
`;

type Props = {
    viewer: CheckoutHelp_viewer$key | null;
    buyer: CheckoutHelp_buyer$key | null;
};

const CheckoutHelp: FC<Props> = ({ viewer: viewerRef, buyer: buyerRef }) => {
    const viewer = useFragment(viewerFragment, viewerRef);
    const buyer = useFragment(buyerFragment, buyerRef);
    const { rootState } = usePrerenderedCheckoutStore();

    if (!viewer || rootState === 'ENABLED_IN_BACKGROUND') {
        return null;
    }

    return (
        <Suspense fallback={null}>
            <CheckoutHelpContent viewer={viewer} buyer={buyer} />
        </Suspense>
    );
};

export default CheckoutHelp;
